// const baseUrl = 'https://server.coinima.io/';
const baseUrl = 'http://192.168.100.144:5000/';

export { 
    baseUrl
}